import { c as createStore } from './index-54dd34b7.js';
import { s as siteType } from './currency-49e0d692.js';

const products = '[{ "commercialReference": "M9F23201", "description": "Multi9 C60 - disjoncteur - 2P - courbe D - 3A - 10kA - 480Y/277V - UL1077", "imgUrl": "https://download.schneider-electric.com/files?p_Doc_Ref=PB116661&p_File_Type=rendition_113_png&default_image=DefaultProductImage.png", "imgAlt": "Multi9 C60 - disjoncteur - 2P - courbe D - 3A - 10kA - 480Y/277V - UL1077" },{ "commercialReference": "ZB6CE8", "description": "Multi9 C60 - disjoncteur - 2P - courbe D - 3A - 10kA - 480Y/277V - UL1077", "imgUrl": "https://download.schneider-electric.com/files?p_Doc_Ref=PB116661&p_File_Type=rendition_113_png&default_image=DefaultProductImage.png", "imgAlt": "Multi9 C60 - disjoncteur - 2P - courbe D - 3A - 10kA - 480Y/277V - UL1077" },{ "commercialReference": "4543545435436554365654", "description": "Multi9 C60 - disjoncteur - 2P - courbe D - 3A - 10kA - 480Y/277V - UL1077", "imgUrl": "https://download.schneider-electric.com/files?p_Doc_Ref=PB116661&p_File_Type=rendition_113_png&default_image=DefaultProductImage.png", "imgAlt": "Multi9 C60 - disjoncteur - 2P - courbe D - 3A - 10kA - 480Y/277V - UL1077" },{ "commercialReference": "K2F013NLH", "description": "Multi9 C60 - disjoncteur - 2P - courbe D - 3A - 10kA - 480Y/277V - UL1077", "imgUrl": "https://download.schneider-electric.com/files?p_Doc_Ref=PB116661&p_File_Type=rendition_113_png&default_image=DefaultProductImage.png", "imgAlt": "Multi9 C60 - disjoncteur - 2P - courbe D - 3A - 10kA - 480Y/277V - UL1077" },{ "commercialReference": "XB5AK125G5", "description": "Multi9 C60 - disjoncteur - 2P - courbe D - 3A - 10kA - 480Y/277V - UL1077", "imgUrl": "https://download.schneider-electric.com/files?p_Doc_Ref=PB116661&p_File_Type=rendition_113_png&default_image=DefaultProductImage.png", "imgAlt": "Multi9 C60 - disjoncteur - 2P - courbe D - 3A - 10kA - 480Y/277V - UL1077" }]';
const additionalDistributors = '{"XB5AK125G5": [{ "id":"XB5AK125G5", "name":"APC", "logoUrl":"https://www.se.com/ww/shop-static/assets/images/brand/apc_brand.gif", "isAvailable": "true", "buyUrl":"https://www.apc.com/shop/fr/fr/products/P-SMT750IC", "stockLabel":"Available on APC.com", "showPrice": "false", "isFavorite": "null", "retailerSite": "https://www.apc.com"}]}';

const APP_NAME = 'pesAppTest';
const getSettings = () => {
  return localStorage.getItem(APP_NAME);
};
const DEFAULT_SETTINGS = {
  appType: 'pesCatalog',
  host: 'https://www.se.com/',
  endpoint: 'product/',
  base_dir: 'catalogBrowse',
  siteType: siteType.B2B,
  showCustomPrice: false,
  showCatalogPrice: true,
  customPrice: {},
  returnBreadcrumbs: (list) => {
    console.log(JSON.stringify(list));
  },
  showBreadcrumbs: true,
  showBuyOnline: false,
  showLinks: true,
  showCompare: false,
  showRecentlyViewed: false,
  showFaq: false,
  language: 'en',
  country: 'us',
  page: '',
  pageId: '',
  usePesRouter: true,
  pesRouterNavigation: 'path',
  showDiscountedPrice: true,
  showDocuments: true,
  dir: 'ltr',
  products,
  additionalDistributors,
  searchParams: '{}',
  ddcAppSource: 'PES_MS_SE',
  hostType: 'Atg',
  useS3: false,
  externalHost: 'https://www.se.com/',
  ddcAllProductsUrl: '',
};
const restoreSettings = () => {
  const settings = getSettings();
  if (!settings) {
    return DEFAULT_SETTINGS;
  }
  return JSON.parse(settings);
};
const getDefaultState = () => {
  return window.location.search.indexOf('use-defaults=true') !== -1
    ? DEFAULT_SETTINGS
    : Object.assign(Object.assign({}, DEFAULT_SETTINGS), restoreSettings());
};
const defaultState = getDefaultState();
const store = createStore(defaultState);
const state = store;
const saveSettings = () => {
  if (typeof window.Proxy === 'function') {
    localStorage.setItem(APP_NAME, JSON.stringify(store.state));
  }
  else {
    const objToSave = {};
    Object.keys(DEFAULT_SETTINGS).forEach((key) => {
      objToSave[key] = store.get(key);
    });
    localStorage.setItem(APP_NAME, JSON.stringify(objToSave));
  }
};
const updateStorage = (data) => {
  localStorage.setItem(APP_NAME, data);
};
store.on('set', saveSettings);
var HostTypeValues;
(function (HostTypeValues) {
  HostTypeValues["Atg"] = "Atg";
  HostTypeValues["Spryker"] = "Spryker";
})(HostTypeValues || (HostTypeValues = {}));

export { HostTypeValues as H, state as a, getSettings as g, store as s, updateStorage as u };
